import { Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";

export enum ScheduleTabType {
  WYND = "Wynd",
  ALEN = "Alen",
}

function useScheduleTab({ options }: { options: ScheduleTabType[] }) {
  const [currentTab, setCurrentTab] = useState<ScheduleTabType>(
    ScheduleTabType.WYND
  );
  useEffect(() => {
    if (options.length > 0) {
      setCurrentTab(options[0]);
    }
  }, [options]);
  const tabElement =
    options.length > 1 ? (
      <Tabs
        value={currentTab}
        onChange={(_, newValue: ScheduleTabType) => setCurrentTab(newValue)}
      >
        {options.map((option) => (
          <Tab key={option} label={option} value={option} />
        ))}
      </Tabs>
    ) : null;

  return {
    currentTab,
    tabElement,
  };
}

export default useScheduleTab;
